// Parser de "Próximos Pasos" para uso en componentes del portal cliente.
// Mantener la lógica alineada con `parseProximosPasos` del backend
// (`taxticbackend/src/utils/buildProposalHTMLv2.js`) para asegurar que el
// portal y el PDF interpreten el mismo texto igual.
//
// Devuelve:
//   { estructurado: false, bloques: [], textoBruto: "" } si vacio
//   { estructurado: true,  bloques: [{titulo, descripcion}, ...], textoBruto }
//     si hay 2+ bloques separados por linea en blanco
//   { estructurado: false, bloques: [], textoBruto } si hay 1 solo bloque
//     o el texto no respeta la convencion -> caller renderiza como prosa.

export function parseProximosPasos(texto) {
  if (!texto || !texto.trim()) {
    return { estructurado: false, bloques: [], textoBruto: "" };
  }
  const textoBruto = texto.trim();
  const bloquesRaw = textoBruto
    .split(/\n{2,}/)
    .map((b) => b.trim())
    .filter(Boolean);
  if (bloquesRaw.length < 2) {
    return { estructurado: false, bloques: [], textoBruto };
  }
  const bloques = bloquesRaw
    .slice(0, 5)
    .map((bloque) => {
      const lineas = bloque
        .split("\n")
        .map((l) => l.trim())
        .filter(Boolean);
      return {
        titulo: lineas[0] || "",
        descripcion: lineas.slice(1).join(" ") || "",
      };
    })
    .filter((b) => b.titulo);
  if (bloques.length < 2) {
    return { estructurado: false, bloques: [], textoBruto };
  }
  return { estructurado: true, bloques, textoBruto };
}
